// Blog article metadata (ES + CA).
// Each article also has its own body JSX under /pages/blog/*.
import { useLang } from "@/lib/i18n";

export const blogArticles = [
  {
    slug: "ataques-panico-despues-cancer",
    title: {
      es: "Ataques de pánico después del cáncer: cómo identificarlos y qué hacer",
      ca: "Atacs de pànic després del càncer: com identificar-los i què fer",
    },
    metaTitle: {
      es: "Ataques de pánico después del cáncer | Método TAO",
      ca: "Atacs de pànic després del càncer | Mètode TAO",
    },
    description: {
      es: "Los ataques de pánico son frecuentes en supervivientes oncológicas. Cómo distinguirlos de una urgencia médica, qué hacer en los primeros 60 segundos y cuándo pedir ayuda.",
      ca: "Els atacs de pànic són freqüents en supervivents oncològiques. Com distingir-los d'una urgència mèdica, què fer en els primers 60 segons i quan demanar ajuda.",
    },
    excerpt: {
      es: "«¿Me está pasando algo? ¿Es una recidiva?». Los ataques de pánico son una respuesta específica del sistema nervioso tras el trauma médico del cáncer. Aprende a distinguirlos de una urgencia real, gestiona los primeros 60 segundos y sabe cuándo pedir ayuda.",
      ca: "«M'està passant alguna cosa? És una recidiva?». Els atacs de pànic són una resposta específica del sistema nerviós després del trauma mèdic del càncer. Aprèn a distingir-los d'una urgència real, gestiona els primers 60 segons i sap quan demanar ajuda.",
    },
    publishedAt: "2026-09-30",
    readingMinutes: 8,
    category: { es: "Oncología · Ansiedad", ca: "Oncologia · Ansietat" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/jzsvdpdw_compasion.png",
    keywords: [
      "ataques de pánico después del cáncer",
      "crisis de pánico superviviente cáncer",
      "diferencia ataque pánico urgencia médica",
      "pánico y cáncer de mama",
      "ansiedad oncológica ataques",
      "5-4-3-2-1 anclaje",
      "cómo parar un ataque de pánico",
      "Método TAO ansiedad",
    ],
  },
  {
    slug: "ansiedad-hormonoterapia",
    title: {
      es: "Ansiedad y hormonoterapia: efectos secundarios psíquicos del tratamiento adyuvante",
      ca: "Ansietat i hormonoteràpia: efectes secundaris psíquics del tractament adjuvant",
    },
    metaTitle: {
      es: "Ansiedad y hormonoterapia | Método TAO",
      ca: "Ansietat i hormonoteràpia | Mètode TAO",
    },
    description: {
      es: "Tamoxifeno, letrozol, anastrozol, exemestano: los tratamientos endocrinos alteran serotonina, GABA y sueño. Qué es normal, qué no lo es y cómo trabajar la ansiedad durante los 5-10 años de hormonoterapia.",
      ca: "Tamoxifèn, letrozol, anastrozol, exemestà: els tractaments endocrins alteren serotonina, GABA i son. Què és normal, què no ho és i com treballar l'ansietat durant els 5-10 anys d'hormonoteràpia.",
    },
    excerpt: {
      es: "La hormonoterapia oncológica no es solo «una pastilla más»: es una modificación farmacológica sostenida del sistema nervioso durante 5-10 años. La ansiedad, el insomnio y la irritabilidad son efectos reales y documentados. Cómo trabajar con ellos sin abandonar el tratamiento.",
      ca: "L'hormonoteràpia oncològica no és només «una pastilla més»: és una modificació farmacològica sostinguda del sistema nerviós durant 5-10 anys. L'ansietat, l'insomni i la irritabilitat són efectes reals i documentats. Com treballar-hi sense abandonar el tractament.",
    },
    publishedAt: "2026-09-30",
    readingMinutes: 8,
    category: { es: "Oncología · Ansiedad", ca: "Oncologia · Ansietat" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/jzsvdpdw_compasion.png",
    keywords: [
      "ansiedad hormonoterapia",
      "tamoxifeno ansiedad",
      "letrozol ansiedad efectos secundarios",
      "anastrozol insomnio",
      "exemestano estado ánimo",
      "sofocos ansiedad hormonoterapia",
      "adherencia hormonoterapia",
      "psicooncología efectos secundarios",
      "Método TAO",
    ],
  },
  {
    slug: "ansiedad-quimioterapia",
    title: {
      es: "Ansiedad y quimioterapia: cómo gestionar la ansiedad anticipatoria antes, durante y después de cada ciclo",
      ca: "Ansietat i quimioteràpia: com gestionar l'ansietat anticipatòria abans, durant i després de cada cicle",
    },
    metaTitle: {
      es: "Ansiedad y quimioterapia | Método TAO",
      ca: "Ansietat i quimioteràpia | Mètode TAO",
    },
    description: {
      es: "Hasta el 40% de pacientes oncológicos experimenta ansiedad anticipatoria a la quimioterapia. Por qué el cuerpo se anticipa, los 3 momentos críticos del ciclo, y herramientas concretas cuerpo-mente para cada uno.",
      ca: "Fins al 40% de pacients oncològics experimenta ansietat anticipatòria a la quimioteràpia. Per què el cos s'anticipa, els 3 moments crítics del cicle, i eines concretes cos-ment per a cadascun.",
    },
    excerpt: {
      es: "La noche anterior no puedes dormir. En el camino al hospital sientes que quieres salir corriendo. Días 3-5 post-ciclo, el bajón emocional. La ansiedad de quimio es condicionamiento clásico — real y desactivable. Guía completa para pacientes y familiares.",
      ca: "La nit anterior no pots dormir. Al camí a l'hospital sents que vols sortir corrents. Dies 3-5 post-cicle, la baixada emocional. L'ansietat de quimio és condicionament clàssic — real i desactivable. Guia completa per a pacients i familiars.",
    },
    publishedAt: "2026-09-30",
    readingMinutes: 8,
    category: { es: "Oncología · Ansiedad", ca: "Oncologia · Ansietat" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/jzsvdpdw_compasion.png",
    keywords: [
      "ansiedad antes de la quimio",
      "ansiedad anticipatoria quimioterapia",
      "no puedo dormir la noche antes de la quimio",
      "náusea anticipatoria quimio",
      "miedo a la quimio",
      "gestión ansiedad tratamiento oncológico",
      "cáncer y ansiedad",
      "yoga oncológico ansiedad",
      "Método TAO",
    ],
  },
  {
    slug: "ansiedad-despues-cancer",
    title: {
      es: "Ansiedad después del cáncer: por qué persiste y cómo trabajar con ella",
      ca: "Ansietat després del càncer: per què persisteix i com treballar-la",
    },
    metaTitle: {
      es: "Ansiedad después del cáncer | Método TAO",
      ca: "Ansietat després del càncer | Mètode TAO",
    },
    description: {
      es: "La ansiedad post-oncológica afecta al 19-32% de las supervivientes hasta 10 años después del diagnóstico. Guía clínica y cuerpo-mente para entenderla y trabajarla sin sumar culpa.",
      ca: "L'ansietat post-oncològica afecta el 19-32% de les supervivents fins a 10 anys després del diagnòstic. Guia clínica i cos-ment per entendre-la i treballar-la sense afegir culpa.",
    },
    excerpt: {
      es: "«Si estoy bien, ¿por qué estoy así?». La ansiedad que aparece cuando terminan los tratamientos oncológicos no es debilidad ni recaída. Es procesamiento retardado. Cómo se manifiesta, por qué las técnicas genéricas no siempre funcionan, y un enfoque cuerpo-mente en tres capas basado en la evidencia clínica actual.",
      ca: "«Si estic bé, per què estic així?». L'ansietat que apareix quan acaben els tractaments oncològics no és debilitat ni recaiguda. És processament retardat. Com es manifesta, per què les tècniques genèriques no sempre funcionen, i un enfocament cos-ment en tres capes basat en l'evidència clínica actual.",
    },
    publishedAt: "2026-09-28",
    readingMinutes: 12,
    category: { es: "Oncología · Ansiedad", ca: "Oncologia · Ansietat" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/jzsvdpdw_compasion.png",
    keywords: [
      "ansiedad después del cáncer",
      "ansiedad post-oncológica",
      "miedo a la recurrencia cáncer",
      "scanxiety ansiedad revisiones",
      "supervivientes cáncer ansiedad",
      "ansiedad cáncer de mama",
      "regulación sistema nervioso oncología",
      "psicooncología España",
      "yoga oncológico ansiedad",
      "ansiedad después del alta oncológica",
      "Método TAO ansiedad",
    ],
  },
  {
    slug: "si-fue-cancer-carcinoma-ductal-in-situ",
    title: {
      es: "«Lo tuyo no fue cáncer, cáncer»: por qué el carcinoma ductal in situ sí es cáncer",
      ca: "«El teu no va ser càncer, càncer»: per què el carcinoma ductal in situ sí és càncer",
    },
    metaTitle: {
      es: "Carcinoma ductal in situ sí es cáncer | Método TAO",
      ca: "Carcinoma ductal in situ sí és càncer | Mètode TAO",
    },
    description: {
      es: "Un familiar cercano dijo que lo mío «no fue cáncer, porque fue hormonal». Escribo sobre la jerarquía silenciosa de cánceres, qué es un carcinoma ductal in situ grado 2, y la segunda herida de la invalidación desde la familia.",
      ca: "Un familiar proper va dir que el meu «no va ser càncer, perquè va ser hormonal». Escric sobre la jerarquia silenciosa de càncers, què és un carcinoma ductal in situ grau 2, i la segona ferida de la invalidació des de la família.",
    },
    excerpt: {
      es: "«Lo de mi amiga sí que fue cáncer. Lo tuyo no fue cáncer. Lo tuyo fue hormonal.» Un carcinoma ductal in situ grado 2 SÍ es cáncer. Te cuento por qué existe la jerarquía silenciosa de diagnósticos, qué dice la evidencia clínica y qué hacer cuando la invalidación viene de tu propia familia.",
      ca: "«El de la meva amiga sí que va ser càncer. El teu no va ser càncer. El teu va ser hormonal.» Un carcinoma ductal in situ grau 2 SÍ és càncer. T'explico per què existeix la jerarquia silenciosa de diagnòstics, què diu l'evidència clínica i què fer quan la invalidació ve de la teva pròpia família.",
    },
    publishedAt: "2026-10-01",
    readingMinutes: 10,
    category: { es: "Oncología · Invalidación", ca: "Oncologia · Invalidació" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/jzsvdpdw_compasion.png",
    keywords: [
      "carcinoma ductal in situ es cáncer",
      "CDIS grado 2 tratamiento",
      "cáncer hormonal sí es cáncer",
      "invalidación cáncer familia",
      "segunda herida psicooncología",
      "jerarquía cánceres estigma",
      "cáncer de mama estadio 0",
      "supervivientes cáncer familia minimiza",
      "mes rosa cáncer de mama",
      "carcinoma ductal in situ",
      "Método TAO",
    ],
  },
  {
    slug: "derecho-olvido-oncologico",
    title: {
      es: "Derecho al olvido oncológico: la ley que protege a quien ha superado un cáncer",
      ca: "Dret a l'oblit oncològic: la llei que protegeix qui ha superat un càncer",
    },
    description: {
      es: "Desde junio de 2023 España reconoce el derecho al olvido oncológico: 5 años después del final del tratamiento sin recaídas, no estás obligada a declarar tu cáncer al contratar seguros, hipotecas o préstamos. Te explico qué es, qué cubre y cómo ejercerlo.",
      ca: "Des del juny de 2023 Espanya reconeix el dret a l'oblit oncològic: 5 anys després del final del tractament sense recaigudes, no estàs obligada a declarar el teu càncer en contractar assegurances, hipoteques o préstecs. T'explico què és, què cobreix i com exercir-lo.",
    },
    excerpt: {
      es: "Si han pasado 5 años desde el final de tu tratamiento sin recaídas, la ley te protege: ya no estás obligada a declarar el cáncer al pedir un seguro o una hipoteca. Te cuento qué es el derecho al olvido oncológico y cómo ejercerlo.",
      ca: "Si han passat 5 anys des del final del teu tractament sense recaigudes, la llei et protegeix: ja no estàs obligada a declarar el càncer al demanar una assegurança o una hipoteca. T'explico què és el dret a l'oblit oncològic i com exercir-lo.",
    },
    publishedAt: "2026-05-22",
    readingMinutes: 8,
    category: { es: "Derechos · Post-cáncer", ca: "Drets · Post-càncer" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/bz2lfiia_ABRAZO.png",
    keywords: [
      "derecho al olvido oncológico",
      "ley olvido oncológico España",
      "derecho al olvido oncológico Real Decreto-ley 5/2023",
      "seguro vida superviviente cáncer",
      "hipoteca después cáncer",
      "discriminación cáncer seguros",
      "dret a l'oblit oncològic",
      "llei oblit oncològic Espanya",
      "Método TAO",
    ],
  },
  {
    slug: "dia-internacional-fibromialgia-fatiga-cronica",
    title: {
      es: "12 de mayo · Lo que casi nadie entiende sobre la fibromialgia y la fatiga crónica",
      ca: "12 de maig · El que gairebé ningú entén sobre la fibromiàlgia i la fatiga crònica",
    },
    description: {
      es: "Día Internacional de la Fibromialgia y la Fatiga Crónica. El cansancio que no se resuelve durmiendo, la incomprensión social, la presión de seguir el ritmo. Una reflexión honesta desde la experiencia de Marta Montardit.",
      ca: "Dia Internacional de la Fibromiàlgia i la Fatiga Crònica. El cansament que no es resol dormint, la incomprensió social, la pressió de seguir el ritme. Una reflexió honesta des de l'experiència de la Marta Montardit.",
    },
    excerpt: {
      es: "Hoy 12 de mayo es el Día Internacional de la Fibromialgia y la Fatiga Crónica. Te cuento lo que más cuesta que la gente entienda: que es un agotamiento que no se resuelve con descanso. Y que estás harta de justificarte.",
      ca: "Avui 12 de maig és el Dia Internacional de la Fibromiàlgia i la Fatiga Crònica. T'explico el que més costa que la gent entengui: que és un esgotament que no es resol amb descans. I que estàs farta de justificar-te.",
    },
    publishedAt: "2026-02-12",
    readingMinutes: 7,
    category: { es: "Fibromialgia · Fatiga crónica", ca: "Fibromiàlgia · Fatiga crònica" },
    coverImage: "/blog/manta-manos-fibromialgia.png",
    keywords: [
      "día internacional fibromialgia 12 mayo",
      "día internacional fatiga crónica",
      "síndrome fatiga crónica incomprensión",
      "fibromialgia no es pereza",
      "vivir con fatiga crónica",
      "Método TAO",
    ],
  },
  {
    slug: "autocompasion-cancer",
    title: {
      es: "Autocompasión y cáncer: por qué tratarte con amabilidad es medicina",
      ca: "Autocompassió i càncer: per què tractar-te amb amabilitat és medicina",
    },
    description: {
      es: "La autocompasión no es lástima ni dejadez: es una herramienta clínica con evidencia científica que mejora regulación emocional, sueño y calidad de vida en pacientes oncológicas. Te cuento qué es, qué dice la investigación y cómo practicarla.",
      ca: "L'autocompassió no és llàstima ni deixadesa: és una eina clínica amb evidència científica que millora la regulació emocional, el son i la qualitat de vida en pacients oncològiques. T'explico què és, què diu la investigació i com practicar-la.",
    },
    excerpt: {
      es: "Si una amiga estuviera viviendo lo que tú vives ahora, ¿qué le dirías? Pues háblate a ti igual. Te explico qué es la autocompasión, por qué es una herramienta clave en oncología y cómo practicarla en tu día a día.",
      ca: "Si una amiga estigués vivint el que tu vius ara, què li diries? Doncs parla't a tu mateixa igual. T'explico què és l'autocompassió, per què és una eina clau en oncologia i com practicar-la al teu dia a dia.",
    },
    publishedAt: "2026-02-12",
    readingMinutes: 9,
    category: { es: "Cuerpo-mente · Oncología", ca: "Cos-ment · Oncologia" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/jzsvdpdw_compasion.png",
    keywords: ["autocompasión cáncer", "mindful self-compassion oncología", "autocompasión y trauma", "tratarse con amabilidad enfermedad", "Kristin Neff cáncer", "Método TAO"],
  },
  {
    slug: "lenguaje-belico-cancer",
    title: {
      es: "Por qué dejar de hablar de \"lucha\" cuando hablamos de cáncer",
      ca: "Per què deixar de parlar de \"lluita\" quan parlem de càncer",
    },
    description: {
      es: "El lenguaje bélico (luchar, vencer, ser fuerte) traslada a la persona con cáncer una responsabilidad que no le corresponde. Por qué cambiar las palabras y qué decir en su lugar.",
      ca: "El llenguatge bèl·lic (lluitar, vèncer, ser forta) trasllada a la persona amb càncer una responsabilitat que no li correspon. Per què canviar les paraules i què dir en el seu lloc.",
    },
    excerpt: {
      es: "Lucha. Sé fuerte. Vence. Estas palabras, dichas con la mejor intención, ponen una presión enorme. Te cuento por qué importa cambiar el lenguaje cuando hablamos de cáncer y qué decir en su lugar.",
      ca: "Lluita. Sigues forta. Venç. Aquestes paraules, dites amb la millor intenció, posen una pressió enorme. T'explico per què importa canviar el llenguatge quan parlem de càncer i què dir en el seu lloc.",
    },
    publishedAt: "2026-02-11",
    readingMinutes: 8,
    category: { es: "Oncología", ca: "Oncologia" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/8hr2bqtf_ma%20esquena.png",
    keywords: ["lenguaje bélico cáncer", "lucha contra el cáncer", "palabras correctas para hablar de cáncer", "cómo hablar a alguien con cáncer", "acompañamiento cáncer respeto", "Método TAO"],
  },
  {
    slug: "evidencia-cientifica-yoga-oncologico-mindfulness",
    title: {
      es: "Evidencia científica del yoga oncológico, mindfulness y técnicas cuerpo-mente",
      ca: "Evidència científica del ioga oncològic, mindfulness i tècniques cos-ment",
    },
    description: {
      es: "Lo que dicen las guías SIO-ASCO y la NCCN sobre yoga, mindfulness y técnicas cuerpo-mente en oncología. Revisión rigurosa de la evidencia científica disponible para reducir fatiga, ansiedad y depresión en pacientes con cáncer.",
      ca: "El que diuen les guies SIO-ASCO i la NCCN sobre ioga, mindfulness i tècniques cos-ment en oncologia. Revisió rigorosa de l'evidència científica disponible per reduir fatiga, ansietat i depressió en pacients amb càncer.",
    },
    excerpt: {
      es: "¿Hay evidencia real detrás del yoga oncológico, el mindfulness o las técnicas cuerpo-mente? Sí, y mucha. Te resumo las guías clínicas internacionales y los principales ensayos clínicos. Sin tecnicismos pero con las fuentes a la vista.",
      ca: "Hi ha evidència real darrere del ioga oncològic, el mindfulness o les tècniques cos-ment? Sí, i molta. Et resumeixo les guies clíniques internacionals i els principals assajos clínics. Sense tecnicismes però amb les fonts a la vista.",
    },
    publishedAt: "2026-02-11",
    readingMinutes: 9,
    category: { es: "Evidencia · Oncología", ca: "Evidència · Oncologia" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/yvu8p891_WhatsApp%20Image%202026-05-09%20at%2008.24.23yyy.jpeg",
    keywords: ["evidencia científica yoga oncológico", "mindfulness y cáncer estudios", "técnicas cuerpo-mente cáncer evidencia", "yoga reduce fatiga oncológica", "SIO ASCO yoga oncológico", "NCCN yoga cáncer", "Método TAO"],
  },
  {
    slug: "recuperar-confianza-cuerpo-despues-cancer",
    title: {
      es: "Recuperar la confianza en el cuerpo después del cáncer",
      ca: "Recuperar la confiança en el cos després del càncer",
    },
    description: {
      es: "Los duelos invisibles del post-cáncer: pérdida de la normalidad, del cuerpo como lugar seguro, del futuro imaginado. Una guía honesta para quien ha sido dada de alta y aún no se siente bien.",
      ca: "Els dols invisibles del post-càncer: pèrdua de la normalitat, del cos com a lloc segur, del futur imaginat. Una guia honesta per a qui ha estat donada d'alta i encara no se sent bé.",
    },
    excerpt: {
      es: "Te han dado el alta pero no te sientes bien. Es muy frecuente y muy poco visible. Hablo de los duelos invisibles del post-cáncer y de cómo recuperar, despacio, la confianza con el cuerpo.",
      ca: "T'han donat l'alta però no et sents bé. És molt freqüent i molt poc visible. Parlo dels dols invisibles del post-càncer i de com recuperar, a poc a poc, la confiança amb el cos.",
    },
    publishedAt: "2026-02-10",
    readingMinutes: 11,
    category: { es: "Oncología · Post-tratamiento", ca: "Oncologia · Post-tractament" },
    coverImage: "/blog/recuperar-confianza-ventana-manana.png",
    keywords: ["vida después del cáncer", "cuerpo después del cáncer", "me han dado el alta pero no me siento bien", "duelo después del cáncer", "identidad después del cáncer", "secuelas emocionales cáncer", "Método TAO"],
  },
  {
    slug: "diagnostico-cancer-por-donde-empezar",
    title: {
      es: "Acabo de recibir mi diagnóstico de cáncer: por dónde empezar",
      ca: "Acabo de rebre el meu diagnòstic de càncer: per on començar",
    },
    description: {
      es: "Una guía honesta y práctica para los primeros días tras un diagnóstico de cáncer: qué hacer, qué no, qué sentirás y cómo sostenerte. Desde la experiencia personal y profesional de Marta Montardit.",
      ca: "Una guia honesta i pràctica per als primers dies després d'un diagnòstic de càncer: què fer, què no, què sentiràs i com sostenir-te. Des de l'experiència personal i professional de la Marta Montardit.",
    },
    excerpt: {
      es: "Te acaban de decir la palabra cáncer. Te cuento, sin rodeos, qué hacer las primeras semanas, qué emociones esperar y qué cosas pequeñas te pueden sostener. Lo que ojalá me hubieran contado a mí.",
      ca: "Acaben de dir-te la paraula càncer. T'explico, sense embuts, què fer les primeres setmanes, quines emocions esperar i quines coses petites et poden sostenir. El que tant de bo m'haguessin explicat a mi.",
    },
    publishedAt: "2026-02-09",
    readingMinutes: 10,
    category: { es: "Oncología", ca: "Oncologia" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/jfzdenrn_qqqq.jpeg",
    keywords: ["tengo cáncer ahora qué", "me han diagnosticado cáncer", "qué hacer después del diagnóstico de cáncer", "acompañamiento cáncer recién diagnosticado", "cáncer de mama recién diagnosticada", "Método TAO"],
  },
  {
    slug: "fatiga-cronica-despues-cancer-mama",
    title: {
      es: "Fatiga crónica tras el cáncer de mama: la secuela invisible de la que casi nadie habla",
      ca: "Fatiga crònica després del càncer de mama: la seqüela invisible de la qual gairebé ningú parla",
    },
    description: {
      es: "La fatiga crónica oncológica afecta a la mayoría de pacientes que han pasado por un cáncer de mama. Te cuento por qué aparece, su conexión con la fibromialgia y qué ayuda de verdad. Desde mi propia experiencia.",
      ca: "La fatiga crònica oncològica afecta la majoria de pacients que han passat per un càncer de mama. T'explico per què apareix, la seva connexió amb la fibromiàlgia i què ajuda de veritat. Des de la meva pròpia experiència.",
    },
    excerpt: {
      es: "Acabas el tratamiento del cáncer y todo el mundo espera que vuelvas. Pero el cuerpo no vuelve. Hablo de fatiga crónica oncológica, fibromialgia post-cáncer y de lo que sí ayuda — desde mi propia experiencia.",
      ca: "Acabes el tractament del càncer i tothom espera que tornis. Però el cos no torna. Parlo de fatiga crònica oncològica, fibromiàlgia post-càncer i del que sí ajuda — des de la meva pròpia experiència.",
    },
    publishedAt: "2026-02-09",
    readingMinutes: 9,
    category: { es: "Oncología · Fibromialgia", ca: "Oncologia · Fibromiàlgia" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/6egk5xby_1111.jpeg",
    keywords: ["fatiga crónica cáncer de mama", "fatiga oncológica", "fibromialgia después del cáncer", "secuelas cáncer de mama", "cansancio después de quimioterapia", "Método TAO"],
  },
  {
    slug: "yoga-oncologico-online-como-funciona",
    title: {
      es: "Yoga oncológico online: cómo funciona y qué esperar de las primeras sesiones",
      ca: "Ioga oncològic online: com funciona i què esperar de les primeres sessions",
    },
    description: {
      es: "Una guía honesta sobre qué es el yoga oncológico, cómo se trabaja en sesiones online y qué puedes esperar si nunca has practicado. Sin tecnicismos, desde la experiencia real.",
      ca: "Una guia honesta sobre què és el ioga oncològic, com es treballa en sessions online i què pots esperar si no has practicat mai. Sense tecnicismes, des de l'experiència real.",
    },
    excerpt: {
      es: "El yoga oncológico no es yoga normal adaptado. Es otra cosa. Te cuento qué encontrarás en una primera sesión, qué necesitas y por qué la modalidad online a veces es incluso mejor que la presencial.",
      ca: "El ioga oncològic no és ioga normal adaptat. És una altra cosa. T'explico què trobaràs en una primera sessió, què necessites i per què la modalitat online de vegades és fins i tot millor que la presencial.",
    },
    publishedAt: "2026-05-09",
    readingMinutes: 8,
    category: { es: "Oncología", ca: "Oncologia" },
    coverImage: "https://customer-assets.emergentagent.com/job_acompanamiento-tao/artifacts/vuo60b0w_2222.jpeg",
    keywords: ["yoga oncológico online", "yoga durante quimioterapia", "yoga restaurativo cáncer", "yoga oncológico Barcelona", "Método TAO"],
  },
];

const pickLang = (val, lang) => {
  if (val == null) return val;
  if (typeof val === "object" && !Array.isArray(val)) return val[lang] ?? val.es;
  return val;
};

const todayIso = () => new Date().toISOString().slice(0, 10);

/** True when ?preview=1 (or preview=true) is present in the URL. Admin escape hatch. */
const isPreviewMode = () => {
  if (typeof window === "undefined") return false;
  const p = new URLSearchParams(window.location.search).get("preview");
  return p === "1" || p === "true";
};

/** Hide articles whose publishedAt is still in the future, unless preview mode is on. */
const isVisible = (article) =>
  isPreviewMode() || !article.publishedAt || article.publishedAt <= todayIso();

export const getArticleBySlug = (slug) => {
  const a = blogArticles.find((x) => x.slug === slug);
  return a && isVisible(a) ? a : undefined;
};

/**
 * Hook returning localized article list + helper to read a localized article.
 * Future-dated articles are filtered out unless ?preview=1 is present.
 */
export const useBlog = () => {
  const lang = useLang();
  const localized = blogArticles
    .filter(isVisible)
    .map((a) => ({
      ...a,
      title: pickLang(a.title, lang),
      metaTitle: pickLang(a.metaTitle, lang),
      description: pickLang(a.description, lang),
      excerpt: pickLang(a.excerpt, lang),
      category: pickLang(a.category, lang),
    }));
  return {
    lang,
    articles: localized,
    getArticle: (slug) => localized.find((a) => a.slug === slug),
  };
};
